import {
  CASE_CREATION_ORDERS_CHANGE_FILTER_DATES,
  CASE_CREATION_ORDERS_CHANGE_FILTER_STATUSES,
  CASE_CREATION_ORDERS_CHANGE_LOADER,
  CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS,
  CASE_CREATION_ORDERS_CHANGE_SCANNING,
  CASE_CREATION_ORDERS_RECEIVE_ORDERS,
  CASE_CREATION_ORDERS_RESET_PAGE,
  CCOF_RESET_FORM
} from '../mutations/available'

import api from '@/api'
import _ from 'lodash'
import router from "../../router";

export const caseCreationOrdersChangeFilterStatuses = async ({commit, dispatch}, statuses) => {
  commit(CASE_CREATION_ORDERS_CHANGE_FILTER_STATUSES, statuses)
  dispatch('caseCreationOrdersResetPage')
  dispatch('caseCreationOrdersLoad')
}

export const caseCreationOrdersChangeFilterDates = async ({commit, dispatch}, dates) => {
  commit(CASE_CREATION_ORDERS_CHANGE_FILTER_DATES, dates)
  dispatch('caseCreationOrdersResetPage')
  dispatch('caseCreationOrdersLoad')
}

export const caseCreationOrdersResetPage = async ({commit}) => {
  commit(CASE_CREATION_ORDERS_RESET_PAGE)
}

export const caseCreationOrdersLoadOne = async ({commit}, orderId) => {
  commit(CASE_CREATION_ORDERS_CHANGE_LOADER, true)

  try {
    let result = await api.getCaseCreationOrder(orderId)
    commit(CASE_CREATION_ORDERS_RECEIVE_ORDERS, {
      items: [result],
      total: 1
    })
  } catch (e) {
    console.log(e)
  }
  commit(CASE_CREATION_ORDERS_CHANGE_LOADER, false)

}

export const caseCreationOrdersLoad = _.debounce(async ({commit, state}) => {
  const {page, rowsPerPage} = state.caseCreationOrders.pagination

  commit(CASE_CREATION_ORDERS_CHANGE_LOADER, true)

  try {
    let resultFilters = {
      ...state.caseCreationOrders.filters,
      clientId: state.currentClientId
    }
    let result = await api.getCaseCreationOrders((page - 1) * rowsPerPage, rowsPerPage, resultFilters)
    commit(CASE_CREATION_ORDERS_RECEIVE_ORDERS, {
      items: result.items,
      total: result.total
    })
  } catch (e) {
    console.log(e)
  }
  commit(CASE_CREATION_ORDERS_CHANGE_LOADER, false)
}, 250)

export const caseCreationOrdersDecline = async ({commit, state}, {vue, orderId, reason}) => {
  commit(CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS, {orderId: orderId, action: 'decline', value: true})

  try {
    await api.declineCaseCreationOrder(orderId, reason)
    vue.$snotify.success(vue.$t('caseCreationOrders.messages.successDecline'))
    vue.$refs['updateCaseCreationOrderForm'].reset()
    vue.$refs['declineForm'].reset()
    commit(CCOF_RESET_FORM, 'updateCaseCreationOrder')
    router.push({name: 'caseCreationOrders'})
  } catch (e) {
    console.log(e)
  }

  commit(CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS, {orderId: orderId, action: 'decline', value: false})
}

export const caseCreationOrdersCancel = async ({commit, state}, {vue, orderId}) => {
  commit(CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS, {orderId: orderId, action: 'cancel', value: true})

  try {
    await api.cancelCaseCreationOrder(orderId)
    vue.$snotify.success(vue.$t('caseCreationOrders.messages.successCancel'))
    vue.$refs['updateCaseCreationOrderForm'].reset()
    commit(CCOF_RESET_FORM, 'updateCaseCreationOrder')
    router.push({name: 'caseCreationOrders'})
  } catch (e) {
    console.log(e)
  }

  commit(CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS, {orderId: orderId, action: 'cancel', value: false})

}

export const caseCreationOrdersChangeScanning = ({commit}, value) => {
  commit(CASE_CREATION_ORDERS_CHANGE_SCANNING, value)
}

export const caseCreationOrdersScanMaterialCode = async ({commit, state, dispatch, getters}, {vue, code}) => {
  const clientId = state.currentClientId
  const routeName = _.get(router.currentRoute, 'name', null)

  dispatch('caseCreationOrdersChangeScanning', true)

  try {
    const caseCreationOrders = await api.getCaseCreationOrderByMaterialCode(clientId, code)
    const ordersCount = caseCreationOrders.length

    switch (routeName) {
      //Если находимся на странице создания заявки
      case 'createCase': {
        //Если материалов в базе не найдено, заполняем форму
        if (ordersCount === 0) {
          vue.$snotify.success(vue.$t('createCaseCreationOrders.messages.materialCreationSuggest'))
          fillCaseCreationOrderForm('cccoFillMaterialsForm', dispatch, code)

          //Иначе ругаемся, что материалы уже сущестуют
        } else {
          vue.$snotify.warning(vue.$t('createCaseCreationOrders.messages.materialIsAlreadyExists'))
        }

        break
      }
      //Если находимся на странице редактирования заявки
      case 'updateCaseCreationOrder': {
        const canEdit = getters.uccoCanCreate || getters.uccoCanSendToValidation
        // Если можно редактировать
        if (canEdit) {
          // Если материалов нет в базе, создаем
          if (ordersCount === 0) {
            vue.$snotify.success(vue.$t('createCaseCreationOrders.messages.materialCreationSuggest'))
            fillCaseCreationOrderForm('uccoFillMaterialsForm', dispatch, code)

            // Иначе ругаемся, что материалы существуют
          } else {
            vue.$snotify.warning(vue.$t('createCaseCreationOrders.messages.materialIsAlreadyExists'))
          }

          //Если редактировать нельзя
        } else {
          //Если материала нет в базе, переходим на страницу создания и заполняем форму
          if (ordersCount === 0) {
            vue.$snotify.success(vue.$t('createCaseCreationOrders.messages.materialCreationSuggest'))
            fillCaseCreationOrderForm('cccoFillMaterialsForm', dispatch, code)
            router.push({name: 'createCase'})
            //Если материалы есть в базе, переходим на страницу заявки
          } else {
            goToUpdateCaseCreationOrderPage(vue, caseCreationOrders, code)
          }
        }
        break;
      }

      //Если находимся на любой другой странице
      default: {
        //Если материалов нет в базе, то переходим на страницу создания и заполняем форму
        if (ordersCount === 0) {
          vue.$snotify.success(vue.$t('createCaseCreationOrders.messages.materialCreationSuggest'))
          fillCaseCreationOrderForm('cccoFillMaterialsForm', dispatch, code)
          router.push({name: 'createCase'})

          //Если материалы есть в базе, то переходим на страницу заявки
        } else {
          goToUpdateCaseCreationOrderPage(vue, caseCreationOrders, code)
        }

        break;
      }
    }

  } catch (e) {
    console.log(e)
  }

  dispatch('caseCreationOrdersChangeScanning', false)
}


function fillCaseCreationOrderForm(formName, dispatch, code) {
  dispatch(formName, {
    code: code
  })

  //Сбрасываем значение сразу после установки.
  setTimeout(function () {
    dispatch(formName, null)
  }, 0)
}

function goToUpdateCaseCreationOrderPage(vue, caseCreationOrders, code) {
  const caseCreationOrder = caseCreationOrders[0]
  vue.$snotify.success(`${vue.$t('createCaseCreationOrders.messages.caseCreationOrderFound')}: ${code}`)
  router.push({
    name: 'updateCaseCreationOrder',
    params: {
      id: caseCreationOrder.id
    }
  })
}